import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TransportService } from 'src/app/private/services/transport.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-transport',
  imports: [SharedModule],
  templateUrl: './create-transport.component.html',
  styleUrl: './create-transport.component.scss'
})
export class CreateTransportComponent {

  @Input() type: string = 'Create';
  @Input() transportData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();

  isSubmitted = false;
  btnLoading = false;

  transportForm: FormGroup;

  statusOptions = ["Active", "Inactive"];
  currencyOptions = ["INR", "USD", "EUR"];
  vehicleTypeOptions = ["AC Bus", "Non-AC Bus", "Tempo", "Van", "Car"];
  amenitiesOptions = [
    { label: "AC", value: "AC" },
    { label: "GPS", value: "GPS" },
    { label: "CCTV", value: "CCTV" },
    { label: "First Aid", value: "First Aid" },
    { label: "WiFi", value: "WiFi" },
    { label: "Music System", value: "Music System" },
    { label: "Fire Extinguisher", value: "Fire Extinguisher" }
  ];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: TransportService,
    private localStorage: LocalStorageService
  ) {
    this.transportForm = this.fb.group({
      route_name: ['', Validators.required],
      pickup_point: ['', Validators.required],
      drop_point: ['', Validators.required],
      capacity: ['', [Validators.required, Validators.min(1)]],
      fee_amount: ['', [Validators.required, Validators.min(0)]],
      currency: ['INR', Validators.required],
      vehicle_type: ['', Validators.required],
      amenities: [[]],
      driver_details: [''],
      status: ['Active', Validators.required],
      organization_id: [this.localStorage.getOrganizationId() || ''],
      campus_id: [this.localStorage.getCampusId() || '']
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.transportData) {
      console.log('Updating transport with data:', this.transportData);

      // Handle facilities object structure
      const facilities = this.transportData.facilities || {};
      
      this.transportForm.patchValue({
        route_name: this.transportData.route_name,
        pickup_point: this.transportData.pickup_point,
        drop_point: this.transportData.drop_point,
        capacity: this.transportData.capacity,
        fee_amount: this.transportData.fee_amount,
        currency: this.transportData.currency,
        vehicle_type: facilities.vehicle_type || '',
        amenities: facilities.amenities || [],
        driver_details: facilities.driver_details || '',
        status: this.transportData.status,
        organization_id: this.transportData.organization_id,
        campus_id: this.transportData.campus_id
      });
    }
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.transportForm.valid) {
      this.btnLoading = true;
      
      // Prepare payload with facilities object structure
      const formValues = this.transportForm.value;
      const payload = {
        organization_id: formValues.organization_id,
        campus_id: formValues.campus_id,
        route_name: formValues.route_name,
        pickup_point: formValues.pickup_point,
        drop_point: formValues.drop_point,
        capacity: formValues.capacity,
        fee_amount: formValues.fee_amount,
        currency: formValues.currency,
        facilities: {
          amenities: formValues.amenities || [],
          driver_details: formValues.driver_details || '',
          vehicle_type: formValues.vehicle_type
        },
        status: formValues.status
      };

      const apiCall = this.type === 'Create'
        ? this.api.createTransport(payload)
        : this.api.updateTransport({
          id: this.transportData.id,
          ...payload
        });

      apiCall.subscribe({
        next: (res) => {
          this.messageService.add({ 
            severity: 'success', 
            summary: 'Success', 
            detail: `Transport ${this.type === 'Create' ? 'created' : 'updated'} successfully` 
          });
          this.transportForm.reset();
          this.isSubmitted = false;
          this.reload.emit();
          this.handleCloseDialog();
          this.btnLoading = false;
        },
        error: (err) => {
          this.messageService.add({ 
            severity: 'error', 
            summary: 'Error', 
            detail: `Failed to ${this.type.toLowerCase()} transport` 
          });
          this.btnLoading = false;
        }
      });
    } else {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Validation Error', 
        detail: 'Please fill all required fields' 
      });
    }
  }
}